import service from "@/plugins/request";

// 词条列表
export function apiEntryList(params) {
  return service({
    url: "/v1/entry/treeList",
    method: "get",
    params: params
  });
}

// 游戏编辑
export function apiEntryEdit(params) {
  return service({
    url: "/v1/protected/entry/edit",
    method: "post",
    data: params,
    successToast: true,
    errorToast: true
  });
}

// 开启or关闭筛选器
export function apiEntrySwitchFilter(params) {
  return service({
    url: "/v1/protected/entry/switchFilter",
    method: "post",
    data: params,
    successToast: true,
    errorToast: true
  });
}

// wiki词条列表
export function apiWikiAllEntryList(params) {
  return service({
    url: "/v1/entry/query-list",
    method: "get",
    params: params
  });
}
